export default (type, payload = {}) => ({
  type,
  payload,
  action: true,
});
